import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { useTranslations } from '../../../../hooks/useTranslations';
import { SEARCH_PREVIEW_HEADER } from './constants';
import type { SearchPreviewHeaderProps } from './types';

/**
 * Search Preview header component. This component is used to display the search query.
 */
export const SearchPreviewHeader: FC<SearchPreviewHeaderProps> = ({ query }) => {
  const { getTestId } = useTestId();
  const { translations } = useTranslations();

  return (
    <Typography
      data-testid={getTestId(SEARCH_PREVIEW_HEADER)}
      fontWeight="bold"
      variant="h6"
      component="h6"
      color="textPrimary"
    >
      {`${translations.popularSearchQueries} ”${(query ?? '').trim()}”`}
    </Typography>
  );
};
